import React from 'react';
import { Layout, Typography, Button, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ExerciseList from '../components/Practice/ExerciseList';

const { Content, Header } = Layout;
const { Title } = Typography;

/**
 * PracticePage
 * Main container page for Practice Exercises
 */
const PracticePage = () => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ background: '#fff', padding: '0 16px', display: 'flex', alignItems: 'center' }}>
        <Space>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate('/dashboard')}
          >
            Zurück
          </Button>
          <Title level={4} style={{ margin: 0 }}>Übungen</Title>
        </Space>
      </Header>

      <Content style={{ background: '#f0f2f5' }}>
        <ExerciseList />
      </Content>
    </Layout>
  );
};

export default PracticePage;
